var Se = Object.defineProperty;
var xe = (n, e, t) => e in n ? Se(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t;
var b = (n, e, t) => xe(n, typeof e != "symbol" ? e + "" : e, t);
import { NodeSelection as se, TextSelection as ie, Plugin as P, PluginKey as T, Selection as L } from "prosemirror-state";
import { c as v, a as F } from "./BlockNoteExtension-C2X7LW-V.js";
import { combineTransactionSteps as Ee, getMarkRange as Ie, posToDOMRect as Be, findChildren as X } from "@tiptap/core";
import Pe from "fast-deep-equal";
import { i as Te, t as Oe, U as De, n as Ae, g as N, a as R, c as ae, m as Me, e as le, f as Le, h as Ne, j as Re, k as Ve, l as Fe, o as q, p as j } from "./nodeToBlock-DJYxfW65.js";
import { aq as ce, a7 as He, ar as de, a4 as W } from "./defaultBlocks-CUZfrbY-.js";
import { yCursorPlugin as $e, defaultSelectionBuilder as Ue, ySyncPlugin as _e, redoCommand as ze, undoCommand as Ke, yUndoPlugin as Ye, yUndoPluginKey as G } from "y-prosemirror";
import * as I from "yjs";
import { PluginKey as ue, Plugin as he, TextSelection as Xe } from "@tiptap/pm/state";
import { dropCursor as qe } from "prosemirror-dropcursor";
import { redo as je, undo as We, history as Ge } from "@tiptap/pm/history";
import { Decoration as A, DecorationSet as V } from "prosemirror-view";
import { v4 as Je } from "uuid";
import { DOMParser as Ze, Slice as Qe } from "@tiptap/pm/model";
import { DOMSerializer as me, Fragment as pe, Slice as et } from "prosemirror-model";
import tt from "rehype-parse";
import ot from "rehype-remark";
import nt from "remark-gfm";
import rt from "remark-stringify";
import { unified as st } from "unified";
import { fromDom as it } from "hast-util-from-dom";
import { visit as at } from "unist-util-visit";
import { splitCell as lt, mergeCells as ct, deleteRow as dt, deleteColumn as ut, addRowBefore as ht, addRowAfter as mt, addColumnBefore as pt, addColumnAfter as ft, CellSelection as gt } from "prosemirror-tables";
const mo = v(({ editor: n }) => {
  const e = F(!1), t = () => n.transact((o) => {
    var s;
    if (o.selection.empty || o.selection instanceof se && (o.selection.node.type.spec.content === "inline*" || ((s = o.selection.node.firstChild) == null ? void 0 : s.type.spec.content) === "inline*") || o.selection instanceof ie && o.doc.textBetween(o.selection.from, o.selection.to).length === 0)
      return !1;
    let r = !1;
    return o.selection.content().content.descendants((i) => (i.type.spec.code && (r = !0), !r)), !r;
  });
  return {
    key: "formattingToolbar",
    store: e,
    mount({ dom: o, signal: r }) {
      let s = !1;
      const i = n.onChange(() => {
        s || e.setState(t());
      }), a = n.onSelectionChange(() => {
        s || e.setState(t());
      });
      o.addEventListener(
        "pointerdown",
        () => {
          s = !0, e.setState(!1);
        },
        { signal: r }
      ), n.prosemirrorView.root.addEventListener(
        "pointerup",
        () => {
          s = !1, n.isFocused() && e.setState(t());
        },
        { signal: r, capture: !0 }
      ), o.addEventListener(
        "pointercancel",
        () => {
          s = !1;
        },
        {
          signal: r,
          capture: !0
        }
      ), r.addEventListener("abort", () => {
        i(), a();
      });
    }
  };
});
function fe(n) {
  const e = Array.from(n.classList).filter(
    (t) => !t.startsWith("bn-")
  ) || [];
  e.length > 0 ? n.className = e.join(" ") : n.removeAttribute("class");
}
function ge(n, e, t, o) {
  var a;
  let r;
  if (e)
    if (Array.isArray(e))
      r = Te(e, n.pmSchema);
    else if (e.type === "tableContent")
      r = Oe(e, n.pmSchema);
    else
      throw new De(e.type);
  else throw new Error("blockContent is required");
  const i = ((o == null ? void 0 : o.document) ?? document).createDocumentFragment();
  for (const l of r)
    if (l.type.name !== "text" && n.schema.inlineContentSchema[l.type.name]) {
      const c = n.schema.inlineContentSpecs[l.type.name].implementation;
      if (c) {
        const m = Ae(
          l,
          n.schema.inlineContentSchema,
          n.schema.styleSchema
        ), u = c.toExternalHTML ? c.toExternalHTML(
          m,
          n
        ) : c.render.call(
          {
            renderType: "dom",
            props: void 0
          },
          m,
          () => {
          },
          n
        );
        if (u) {
          if (i.appendChild(u.dom), u.contentDOM) {
            const p = t.serializeFragment(
              l.content,
              o
            );
            u.contentDOM.dataset.editable = "", u.contentDOM.appendChild(p);
          }
          continue;
        }
      }
    } else if (l.type.name === "text") {
      let c = document.createTextNode(
        l.textContent
      );
      for (const m of l.marks.toReversed())
        if (m.type.name in n.schema.styleSpecs) {
          const u = (n.schema.styleSpecs[m.type.name].implementation.toExternalHTML ?? n.schema.styleSpecs[m.type.name].implementation.render)(m.attrs.stringValue, n);
          u.contentDOM.appendChild(c), c = u.dom;
        } else {
          const u = m.type.spec.toDOM(m, !0), p = me.renderSpec(document, u);
          p.contentDOM.appendChild(c), c = p.dom;
        }
      i.appendChild(c);
    } else {
      const c = t.serializeFragment(
        pe.from([l]),
        o
      );
      i.appendChild(c);
    }
  return i.childNodes.length === 1 && ((a = i.firstChild) == null ? void 0 : a.nodeType) === 1 && fe(i.firstChild), i;
}
function wt(n, e, t, o, r, s, i) {
  var d, g, w, y, E, O, _, z, K, Y;
  const a = (i == null ? void 0 : i.document) ?? document, l = e.pmSchema.nodes.blockContainer, c = (g = (d = l.spec) == null ? void 0 : d.toDOM) == null ? void 0 : g.call(
    d,
    l.create({
      id: t.id,
      ...t.props
    })
  ), m = Array.from(c.dom.attributes), u = e.blockImplementations[t.type].implementation, p = ((w = u.toExternalHTML) == null ? void 0 : w.call(
    {},
    { ...t },
    e
  )) || u.render.call({}, { ...t }, e), h = a.createDocumentFragment();
  if (p.dom.classList.contains("bn-block-content")) {
    const k = [
      ...m,
      ...Array.from(p.dom.attributes)
    ].filter(
      (x) => x.name.startsWith("data") && x.name !== "data-content-type" && x.name !== "data-file-block" && x.name !== "data-node-view-wrapper" && x.name !== "data-node-type" && x.name !== "data-id" && x.name !== "data-editable"
    );
    for (const x of k)
      p.dom.firstChild.setAttribute(x.name, x.value);
    fe(p.dom.firstChild), h.append(...Array.from(p.dom.childNodes));
  } else
    h.append(p.dom);
  if (p.contentDOM && t.content) {
    const k = ge(
      e,
      t.content,
      o,
      i
    );
    p.contentDOM.appendChild(k);
  }
  let f;
  if (r.has(t.type) ? f = "OL" : s.has(t.type) && (f = "UL"), f) {
    if (((y = n.lastChild) == null ? void 0 : y.nodeName) !== f) {
      const k = a.createElement(f);
      f === "OL" && "start" in t.props && t.props.start && ((E = t.props) == null ? void 0 : E.start) !== 1 && k.setAttribute("start", t.props.start + ""), n.append(k);
    }
    n.lastChild.appendChild(h);
  } else
    n.append(h);
  if (t.children && t.children.length > 0) {
    const k = a.createDocumentFragment();
    if (we(
      k,
      e,
      t.children,
      o,
      r,
      s,
      i
    ), ((O = n.lastChild) == null ? void 0 : O.nodeName) === "UL" || ((_ = n.lastChild) == null ? void 0 : _.nodeName) === "OL")
      for (; ((z = k.firstChild) == null ? void 0 : z.nodeName) === "UL" || ((K = k.firstChild) == null ? void 0 : K.nodeName) === "OL"; )
        n.lastChild.lastChild.appendChild(k.firstChild);
    e.pmSchema.nodes[t.type].isInGroup("blockContent") ? n.append(k) : (Y = p.contentDOM) == null || Y.append(k);
  }
}
const we = (n, e, t, o, r, s, i) => {
  for (const a of t)
    wt(
      n,
      e,
      a,
      o,
      r,
      s,
      i
    );
}, yt = (n, e, t, o, r, s) => {
  const a = ((s == null ? void 0 : s.document) ?? document).createDocumentFragment();
  return we(
    a,
    n,
    e,
    t,
    o,
    r,
    s
  ), a;
}, ye = (n, e) => {
  const t = me.fromSchema(n);
  return {
    exportBlocks: (o, r) => {
      const s = yt(
        e,
        o,
        t,
        /* @__PURE__ */ new Set(["numberedListItem"]),
        /* @__PURE__ */ new Set(["bulletListItem", "checkListItem", "toggleListItem"]),
        r
      ), i = document.createElement("div");
      return i.append(s), i.innerHTML;
    },
    exportInlineContent: (o, r) => {
      const s = ge(
        e,
        o,
        t,
        r
      ), i = document.createElement("div");
      return i.append(s.cloneNode(!0)), i.innerHTML;
    }
  };
};
function bt(n, e) {
  if (e === 0)
    return;
  const t = n.resolve(e);
  for (let o = t.depth; o > 0; o--) {
    const r = t.node(o);
    if (ce(r))
      return r.attrs.id;
  }
}
function vt(n) {
  return n.getMeta("paste") ? { type: "paste" } : n.getMeta("uiEvent") === "drop" ? { type: "drop" } : n.getMeta("history$") ? {
    type: n.getMeta("history$").redo ? "redo" : "undo"
  } : n.getMeta("y-sync$") ? n.getMeta("y-sync$").isUndoRedoOperation ? { type: "undo-redo" } : { type: "yjs-remote" } : { type: "local" };
}
function J(n) {
  const e = "__root__", t = {}, o = {}, r = N(n);
  return n.descendants((s, i) => {
    if (!ce(s))
      return !0;
    const a = bt(n, i), l = a ?? e;
    o[l] || (o[l] = []);
    const c = R(s, r);
    return t[s.attrs.id] = { block: c, parentId: a }, o[l].push(s.attrs.id), !0;
  }), { byId: t, childrenByParent: o };
}
function Ct(n, e) {
  const t = /* @__PURE__ */ new Set();
  if (!n || !e)
    return t;
  const o = new Set(n), r = e.filter((d) => o.has(d)), s = n.filter(
    (d) => r.includes(d)
  );
  if (s.length <= 1 || r.length <= 1)
    return t;
  const i = {};
  for (let d = 0; d < s.length; d++)
    i[s[d]] = d;
  const a = r.map((d) => i[d]), l = a.length, c = [], m = [], u = new Array(l).fill(-1), p = (d, g) => {
    let w = 0, y = d.length;
    for (; w < y; ) {
      const E = w + y >>> 1;
      d[E] < g ? w = E + 1 : y = E;
    }
    return w;
  };
  for (let d = 0; d < l; d++) {
    const g = a[d], w = p(c, g);
    w > 0 && (u[d] = m[w - 1]), w === c.length ? (c.push(g), m.push(d)) : (c[w] = g, m[w] = d);
  }
  const h = /* @__PURE__ */ new Set();
  let f = m[m.length - 1] ?? -1;
  for (; f !== -1; )
    h.add(f), f = u[f];
  for (let d = 0; d < r.length; d++)
    h.has(d) || t.add(r[d]);
  return t;
}
function kt(n, e = []) {
  const t = vt(n), o = Ee(n.before, [
    n,
    ...e
  ]), r = J(
    o.before
  ), s = J(
    o.doc
  ), i = [], a = /* @__PURE__ */ new Set();
  Object.keys(s.byId).filter((h) => !(h in r.byId)).forEach((h) => {
    i.push({
      type: "insert",
      block: s.byId[h].block,
      source: t,
      prevBlock: void 0
    }), a.add(h);
  }), Object.keys(r.byId).filter((h) => !(h in s.byId)).forEach((h) => {
    i.push({
      type: "delete",
      block: r.byId[h].block,
      source: t,
      prevBlock: void 0
    }), a.add(h);
  }), Object.keys(s.byId).filter((h) => h in r.byId).forEach((h) => {
    var w, y;
    const f = r.byId[h], d = s.byId[h];
    f.parentId !== d.parentId ? (i.push({
      type: "move",
      block: d.block,
      prevBlock: f.block,
      source: t,
      prevParent: f.parentId ? (w = r.byId[f.parentId]) == null ? void 0 : w.block : void 0,
      currentParent: d.parentId ? (y = s.byId[d.parentId]) == null ? void 0 : y.block : void 0
    }), a.add(h)) : Pe(
      { ...f.block, children: void 0 },
      { ...d.block, children: void 0 }
    ) || (i.push({
      type: "update",
      block: d.block,
      prevBlock: f.block,
      source: t
    }), a.add(h));
  });
  const l = r.childrenByParent, c = s.childrenByParent, m = "__root__", u = /* @__PURE__ */ new Set([
    ...Object.keys(l),
    ...Object.keys(c)
  ]), p = /* @__PURE__ */ new Set();
  return u.forEach((h) => {
    const f = Ct(
      l[h],
      c[h]
    );
    f.size !== 0 && f.forEach((d) => {
      var E, O;
      const g = r.byId[d], w = s.byId[d];
      !g || !w || g.parentId !== w.parentId || a.has(d) || (g.parentId ?? m) !== h || p.has(d) || (p.add(d), i.push({
        type: "move",
        block: w.block,
        prevBlock: g.block,
        source: t,
        prevParent: g.parentId ? (E = r.byId[g.parentId]) == null ? void 0 : E.block : void 0,
        currentParent: w.parentId ? (O = s.byId[w.parentId]) == null ? void 0 : O.block : void 0
      }), a.add(d));
    });
  }), i;
}
function St() {
  const n = (e) => {
    var t;
    if (e.children && "length" in e.children && e.children.length)
      for (let o = e.children.length - 1; o >= 0; o--) {
        const r = e.children[o], s = o + 1 < e.children.length ? e.children[o + 1] : void 0;
        r.type === "element" && r.tagName === "input" && ((t = r.properties) == null ? void 0 : t.type) === "checkbox" && (s == null ? void 0 : s.type) === "element" && s.tagName === "p" ? (s.tagName = "span", s.children.splice(
          0,
          0,
          it(document.createTextNode(" "))
        )) : n(r);
      }
  };
  return n;
}
function xt() {
  return (n) => {
    at(n, "element", (e, t, o) => {
      var r, s, i, a;
      if (o && e.tagName === "video") {
        const l = ((r = e.properties) == null ? void 0 : r.src) || ((s = e.properties) == null ? void 0 : s["data-url"]) || "", c = ((i = e.properties) == null ? void 0 : i.title) || ((a = e.properties) == null ? void 0 : a["data-name"]) || "";
        o.children[t] = {
          type: "text",
          value: `![${c}](${l})`
        };
      }
    });
  };
}
function Et() {
  const n = (e) => {
    let t = e.children.length;
    for (let o = 0; o < t; o++) {
      const r = e.children[o];
      if (r.type === "element" && (n(r), r.tagName === "u"))
        if (r.children.length > 0) {
          e.children.splice(o, 1, ...r.children);
          const s = r.children.length - 1;
          t += s, o += s;
        } else
          e.children.splice(o, 1), t--, o--;
    }
  };
  return n;
}
function be(n) {
  return st().use(tt, { fragment: !0 }).use(xt).use(Et).use(St).use(ot).use(nt).use(rt, {
    handlers: { text: (t) => t.value }
  }).processSync(n).value;
}
function po(n, e, t, o) {
  const s = ye(e, t).exportBlocks(n, o);
  return be(s);
}
function It(n) {
  const e = [];
  return n.descendants((t) => {
    var r, s;
    const o = N(t);
    return t.type.name === "blockContainer" && ((r = t.firstChild) == null ? void 0 : r.type.name) === "blockGroup" ? !0 : t.type.name === "columnList" && t.childCount === 1 ? ((s = t.firstChild) == null || s.forEach((i) => {
      e.push(R(i, o));
    }), !1) : t.type.isInGroup("bnBlock") ? (e.push(R(t, o)), !1) : !0;
  }), e;
}
const fo = v(() => {
  const n = [];
  return {
    key: "blockChange",
    prosemirrorPlugins: [
      new P({
        key: new T("blockChange"),
        filterTransaction: (e) => {
          let t;
          return n.reduce((o, r) => o === !1 ? o : r({
            getChanges() {
              return t || (t = kt(e), t);
            },
            tr: e
          }) !== !1, !0);
        }
      })
    ],
    /**
     * Subscribe to the block change events.
     */
    subscribe(e) {
      return n.push(e), () => {
        n.splice(
          n.indexOf(e),
          1
        );
      };
    }
  };
});
function Z(n) {
  const e = n.charAt(0) === "#" ? n.substring(1, 7) : n, t = parseInt(e.substring(0, 2), 16), o = parseInt(e.substring(2, 4), 16), r = parseInt(e.substring(4, 6), 16), i = [t / 255, o / 255, r / 255].map((l) => l <= 0.03928 ? l / 12.92 : Math.pow((l + 0.055) / 1.055, 2.4));
  return 0.2126 * i[0] + 0.7152 * i[1] + 0.0722 * i[2] <= 0.179;
}
function Bt(n) {
  const e = document.createElement("span");
  e.classList.add("bn-collaboration-cursor__base");
  const t = document.createElement("span");
  t.setAttribute("contentedEditable", "false"), t.classList.add("bn-collaboration-cursor__caret"), t.setAttribute(
    "style",
    `background-color: ${n.color}; color: ${Z(n.color) ? "white" : "black"}`
  );
  const o = document.createElement("span");
  return o.classList.add("bn-collaboration-cursor__label"), o.setAttribute(
    "style",
    `background-color: ${n.color}; color: ${Z(n.color) ? "white" : "black"}`
  ), o.insertBefore(document.createTextNode(n.name), null), t.insertBefore(o, null), e.insertBefore(document.createTextNode("⁠"), null), e.insertBefore(t, null), e.insertBefore(document.createTextNode("⁠"), null), e;
}
const Q = v(
  ({
    options: n
  }) => {
    const e = /* @__PURE__ */ new Map();
    return n.provider && "awareness" in n.provider && typeof n.provider.awareness == "object" && ("setLocalStateField" in n.provider.awareness && typeof n.provider.awareness.setLocalStateField == "function" && n.provider.awareness.setLocalStateField("user", n.user), "on" in n.provider.awareness && typeof n.provider.awareness.on == "function" && n.showCursorLabels !== "always" && n.provider.awareness.on(
      "change",
      ({
        updated: t
      }) => {
        for (const o of t) {
          const r = e.get(o);
          r && (r.element.setAttribute("data-active", ""), r.hideTimeout && clearTimeout(r.hideTimeout), e.set(o, {
            element: r.element,
            hideTimeout: setTimeout(() => {
              r.element.removeAttribute("data-active");
            }, 2e3)
          }));
        }
      }
    )), {
      key: "yCursor",
      prosemirrorPlugins: [
        $e(n.provider.awareness, {
          selectionBuilder: Ue,
          cursorBuilder(t, o) {
            let r = e.get(o);
            if (!r) {
              const s = (n.renderCursor ?? Bt)(t);
              n.showCursorLabels !== "always" && (s.addEventListener("mouseenter", () => {
                const i = e.get(o);
                i.element.setAttribute("data-active", ""), i.hideTimeout && (clearTimeout(i.hideTimeout), e.set(o, {
                  element: i.element,
                  hideTimeout: void 0
                }));
              }), s.addEventListener("mouseleave", () => {
                const i = e.get(o);
                e.set(o, {
                  element: i.element,
                  hideTimeout: setTimeout(() => {
                    i.element.removeAttribute("data-active");
                  }, 2e3)
                });
              })), r = {
                element: s,
                hideTimeout: void 0
              }, e.set(o, r);
            }
            return r.element;
          }
        })
      ],
      dependsOn: ["ySync"],
      updateUser(t) {
        n.provider.awareness.setLocalStateField("user", t);
      }
    };
  }
), H = v(
  ({ options: n }) => ({
    key: "ySync",
    prosemirrorPlugins: [_e(n.fragment)],
    runsBefore: ["default"]
  })
), $ = v(({ editor: n }) => ({
  key: "yUndo",
  prosemirrorPlugins: [Ye({ trackedOrigins: [n] })],
  dependsOn: ["yCursor", "ySync"],
  undoCommand: Ke,
  redoCommand: ze
}));
function Pt(n, e) {
  const t = n.doc;
  if (n._item === null) {
    const o = Array.from(t.share.keys()).find(
      (r) => t.share.get(r) === n
    );
    if (o == null)
      throw new Error("type does not exist in other ydoc");
    return e.get(o, n.constructor);
  } else {
    const o = n._item, r = e.store.clients.get(o.id.client) ?? [], s = I.findIndexSS(r, o.id.clock);
    return r[s].content.type;
  }
}
const go = v(
  ({
    editor: n,
    options: e
  }) => {
    let t;
    const o = F({ isForked: !1 });
    return {
      key: "yForkDoc",
      store: o,
      /**
       * Fork the Y.js document from syncing to the remote,
       * allowing modifications to the document without affecting the remote.
       * These changes can later be rolled back or applied to the remote.
       */
      fork() {
        if (t)
          return;
        const r = e.fragment;
        if (!r)
          throw new Error("No fragment to fork from");
        const s = new I.Doc();
        I.applyUpdate(s, I.encodeStateAsUpdate(r.doc));
        const i = Pt(r, s);
        t = {
          undoStack: G.getState(n.prosemirrorState).undoManager.undoStack,
          originalFragment: r,
          forkedFragment: i
        }, n.unregisterExtension([
          $,
          Q,
          H
        ]);
        const a = {
          ...e,
          fragment: i
        };
        n.registerExtension([
          H(a),
          // No need to register the cursor plugin again, it's a local fork
          $({})
        ]), o.setState({ isForked: !0 });
      },
      /**
       * Resume syncing the Y.js document to the remote
       * If `keepChanges` is true, any changes that have been made to the forked document will be applied to the original document.
       * Otherwise, the original document will be restored and the changes will be discarded.
       */
      merge({ keepChanges: r }) {
        if (!t)
          return;
        n.unregisterExtension(["ySync", "yCursor", "yUndo"]);
        const { originalFragment: s, forkedFragment: i, undoStack: a } = t;
        if (n.registerExtension([
          H(e),
          Q(e),
          $({})
        ]), G.getState(
          n.prosemirrorState
        ).undoManager.undoStack = a, r) {
          const l = I.encodeStateAsUpdate(
            i.doc,
            I.encodeStateVector(s.doc)
          );
          I.applyUpdate(s.doc, l, n);
        }
        t = void 0, o.setState({ isForked: !1 });
      }
    };
  }
), ve = (n, e) => {
  e(n), n.forEach((t) => {
    t instanceof I.XmlElement && ve(t, e);
  });
}, Tt = (n, e) => {
  const t = /* @__PURE__ */ new Map();
  return n.forEach((o) => {
    o instanceof I.XmlElement && ve(o, (r) => {
      if (r.nodeName === "blockContainer" && r.hasAttribute("id")) {
        const s = r.getAttribute("textColor"), i = r.getAttribute("backgroundColor"), a = He.parse({}), l = {
          textColor: s === a.textColor ? void 0 : s,
          backgroundColor: i === a.backgroundColor ? void 0 : i
        };
        (l.textColor || l.backgroundColor) && t.set(r.getAttribute("id"), l);
      }
    });
  }), t.size === 0 ? !1 : (e.doc.descendants((o, r) => {
    if (o.type.name === "blockContainer" && t.has(o.attrs.id)) {
      const s = e.doc.nodeAt(r + 1);
      if (!s)
        throw new Error("No element found");
      e.setNodeMarkup(r + 1, void 0, {
        // preserve existing attributes
        ...s.attrs,
        // add the textColor and backgroundColor attributes
        ...t.get(o.attrs.id)
      });
    }
  }), !0);
}, Ot = [Tt], wo = v(
  ({ options: n }) => {
    let e = !1;
    const t = new ue("schemaMigration");
    return {
      key: "schemaMigration",
      prosemirrorPlugins: [
        new he({
          key: t,
          appendTransaction: (o, r, s) => {
            if (e || // If any of the transactions are not due to a yjs sync, we don't need to run the migration
            !o.some((a) => a.getMeta("y-sync$")) || // If none of the transactions result in a document change, we don't need to run the migration
            o.every((a) => !a.docChanged) || // If the fragment is still empty, we can't run the migration (since it has not yet been applied to the Y.Doc)
            !n.fragment.firstChild)
              return;
            const i = s.tr;
            for (const a of Ot)
              a(n.fragment, i);
            if (e = !0, !!i.docChanged)
              return i;
          }
        })
      ]
    };
  }
), yo = v(
  ({
    editor: n,
    options: e
  }) => ({
    key: "dropCursor",
    prosemirrorPlugins: [
      (e.dropCursor ?? qe)({
        width: 5,
        color: "#ddeeff",
        editor: n
      })
    ]
  })
), bo = v(() => ({
  key: "history",
  prosemirrorPlugins: [Ge()],
  undoCommand: We,
  redoCommand: je
})), vo = v(({ editor: n }) => {
  function e(r) {
    let s = n.prosemirrorView.nodeDOM(r);
    for (; s && s.parentElement; ) {
      if (s.nodeName === "A")
        return s;
      s = s.parentElement;
    }
    return null;
  }
  function t(r, s) {
    return n.transact((i) => {
      const a = i.doc.resolve(r), l = a.marks().find((m) => m.type.name === s);
      if (!l)
        return;
      const c = Ie(a, l.type);
      if (c)
        return {
          range: c,
          mark: l,
          get text() {
            return i.doc.textBetween(c.from, c.to);
          },
          get position() {
            return Be(
              n.prosemirrorView,
              c.from,
              c.to
            ).toJSON();
          }
        };
    });
  }
  function o() {
    return n.transact((r) => {
      const s = r.selection;
      if (s.empty)
        return t(s.anchor, "link");
    });
  }
  return {
    key: "linkToolbar",
    getLinkAtSelection: o,
    getLinkElementAtPos: e,
    getMarkAtPos: t,
    getLinkAtElement(r) {
      return n.transact(() => {
        const s = n.prosemirrorView.posAtDOM(r, 0) + 1;
        return t(s, "link");
      });
    },
    editLink(r, s, i = n.transact((a) => a.selection.anchor)) {
      n.transact((a) => {
        const l = N(a), { range: c } = t(i + 1, "link") || {
          range: {
            from: a.selection.from,
            to: a.selection.to
          }
        };
        c && (a.insertText(s, c.from, c.to), a.addMark(
          c.from,
          c.from + s.length,
          l.mark("link", { href: r })
        ));
      }), n.prosemirrorView.focus();
    },
    deleteLink(r = n.transact((s) => s.selection.anchor)) {
      n.transact((s) => {
        const i = N(s), { range: a } = t(r + 1, "link") || {
          range: {
            from: s.selection.from,
            to: s.selection.to
          }
        };
        a && s.removeMark(a.from, a.to, i.marks.link).setMeta(
          "preventAutolink",
          !0
        );
      }), n.prosemirrorView.focus();
    }
  };
}), Co = [
  "http",
  "https",
  "ftp",
  "ftps",
  "mailto",
  "tel",
  "callto",
  "sms",
  "cid",
  "xmpp"
], ko = "https", Dt = new T("node-selection-keyboard"), So = v(
  () => ({
    key: "nodeSelectionKeyboard",
    prosemirrorPlugins: [
      new P({
        key: Dt,
        props: {
          handleKeyDown: (n, e) => {
            if ("node" in n.state.selection) {
              if (e.ctrlKey || e.metaKey)
                return !1;
              if (e.key.length === 1)
                return e.preventDefault(), !0;
              if (e.key === "Enter" && !e.shiftKey && !e.altKey && !e.ctrlKey && !e.metaKey) {
                const t = n.state.tr;
                return n.dispatch(
                  t.insert(
                    n.state.tr.selection.$to.after(),
                    n.state.schema.nodes.paragraph.createChecked()
                  ).setSelection(
                    new ie(
                      t.doc.resolve(
                        n.state.tr.selection.$to.after() + 1
                      )
                    )
                  )
                ), !0;
              }
            }
            return !1;
          }
        }
      })
    ]
  })
), At = new T("blocknote-placeholder"), xo = v(
  ({
    editor: n,
    options: e
  }) => {
    const t = e.placeholders;
    return {
      key: "placeholder",
      prosemirrorPlugins: [
        new P({
          key: At,
          view: (o) => {
            const r = `placeholder-selector-${Je()}`;
            o.dom.classList.add(r);
            const s = document.createElement("style"), i = n._tiptapEditor.options.injectNonce;
            i && s.setAttribute("nonce", i), o.root instanceof window.ShadowRoot ? o.root.append(s) : o.root.head.appendChild(s);
            const a = s.sheet, l = (c = "") => `.${r} .bn-block-content${c} .bn-inline-content:has(> .ProseMirror-trailingBreak:only-child):before`;
            try {
              const {
                default: c,
                emptyDocument: m,
                ...u
              } = t || {};
              for (const [f, d] of Object.entries(u)) {
                const g = `[data-content-type="${f}"]`;
                a.insertRule(
                  `${l(g)} { content: ${JSON.stringify(
                    d
                  )}; }`
                );
              }
              const p = "[data-is-only-empty-block]", h = "[data-is-empty-and-focused]";
              a.insertRule(
                `${l(p)} { content: ${JSON.stringify(
                  m
                )}; }`
              ), a.insertRule(
                `${l(h)} { content: ${JSON.stringify(
                  c
                )}; }`
              );
            } catch (c) {
              console.warn(
                "Failed to insert placeholder CSS rule - this is likely due to the browser not supporting certain CSS pseudo-element selectors (:has, :only-child:, or :before)",
                c
              );
            }
            return {
              destroy: () => {
                o.root instanceof window.ShadowRoot ? o.root.removeChild(s) : o.root.head.removeChild(s);
              }
            };
          },
          props: {
            decorations: (o) => {
              const { doc: r, selection: s } = o;
              if (!n.isEditable || !s.empty || s.$from.parent.type.spec.code)
                return;
              const i = [];
              o.doc.content.size === 6 && i.push(
                A.node(2, 4, {
                  "data-is-only-empty-block": "true"
                })
              );
              const a = s.$anchor, l = a.parent;
              if (l.content.size === 0) {
                const c = a.before();
                i.push(
                  A.node(c, c + l.nodeSize, {
                    "data-is-empty-and-focused": "true"
                  })
                );
              }
              return V.create(r, i);
            }
          }
        })
      ]
    };
  }
), ee = new T("previous-blocks"), Mt = {
  // Numbered List Items
  index: "index",
  // Headings
  level: "level",
  // All Blocks
  type: "type",
  depth: "depth",
  "depth-change": "depth-change"
}, Eo = v(() => {
  let n;
  return {
    key: "previousBlockType",
    prosemirrorPlugins: [
      new P({
        key: ee,
        view(e) {
          return {
            update: async (t, o) => {
              var r;
              ((r = this.key) == null ? void 0 : r.getState(t.state).updatedBlocks.size) > 0 && (n = setTimeout(() => {
                t.dispatch(
                  t.state.tr.setMeta(ee, { clearUpdate: !0 })
                );
              }, 0));
            },
            destroy: () => {
              n && clearTimeout(n);
            }
          };
        },
        state: {
          init() {
            return {
              // Block attributes, by block ID, from just before the previous transaction.
              prevTransactionOldBlockAttrs: {},
              // Block attributes, by block ID, from just before the current transaction.
              currentTransactionOldBlockAttrs: {},
              // Set of IDs of blocks whose attributes changed from the current transaction.
              updatedBlocks: /* @__PURE__ */ new Set()
            };
          },
          apply(e, t, o, r) {
            if (t.currentTransactionOldBlockAttrs = {}, t.updatedBlocks.clear(), !e.docChanged || o.doc.eq(r.doc))
              return t;
            const s = {}, i = X(
              o.doc,
              (c) => c.attrs.id
            ), a = new Map(
              i.map((c) => [c.node.attrs.id, c])
            ), l = X(
              r.doc,
              (c) => c.attrs.id
            );
            for (const c of l) {
              const m = a.get(c.node.attrs.id), u = m == null ? void 0 : m.node.firstChild, p = c.node.firstChild;
              if (m && u && p) {
                const h = {
                  index: p.attrs.index,
                  level: p.attrs.level,
                  type: p.type.name,
                  depth: r.doc.resolve(c.pos).depth
                }, f = {
                  index: u.attrs.index,
                  level: u.attrs.level,
                  type: u.type.name,
                  depth: o.doc.resolve(m.pos).depth
                };
                s[c.node.attrs.id] = f, t.currentTransactionOldBlockAttrs[c.node.attrs.id] = f, JSON.stringify(f) !== JSON.stringify(h) && (f["depth-change"] = f.depth - h.depth, t.updatedBlocks.add(c.node.attrs.id));
              }
            }
            return t.prevTransactionOldBlockAttrs = s, t;
          }
        },
        props: {
          decorations(e) {
            const t = this.getState(e);
            if (t.updatedBlocks.size === 0)
              return;
            const o = [];
            return e.doc.descendants((r, s) => {
              if (!r.attrs.id || !t.updatedBlocks.has(r.attrs.id))
                return;
              const i = t.currentTransactionOldBlockAttrs[r.attrs.id], a = {};
              for (const [c, m] of Object.entries(i))
                a["data-prev-" + Mt[c]] = m || "none";
              const l = A.node(s, s + r.nodeSize, {
                ...a
              });
              o.push(l);
            }), V.create(e.doc, o);
          }
        }
      })
    ]
  };
});
function Ce(n, e) {
  var t, o;
  for (; n && n.parentElement && n.parentElement !== e.dom && ((t = n.getAttribute) == null ? void 0 : t.call(n, "data-node-type")) !== "blockContainer"; )
    n = n.parentElement;
  if (((o = n.getAttribute) == null ? void 0 : o.call(n, "data-node-type")) === "blockContainer")
    return { node: n, id: n.getAttribute("data-id") };
}
class B extends L {
  constructor(t, o) {
    super(t, o);
    b(this, "nodes");
    const r = t.node();
    this.nodes = [], t.doc.nodesBetween(t.pos, o.pos, (s, i, a) => {
      if (a !== null && a.eq(r))
        return this.nodes.push(s), !1;
    });
  }
  static create(t, o, r = o) {
    return new B(t.resolve(o), t.resolve(r));
  }
  content() {
    return new et(pe.from(this.nodes), 0, 0);
  }
  eq(t) {
    if (!(t instanceof B) || this.nodes.length !== t.nodes.length || this.from !== t.from || this.to !== t.to)
      return !1;
    for (let o = 0; o < this.nodes.length; o++)
      if (!this.nodes[o].eq(t.nodes[o]))
        return !1;
    return !0;
  }
  map(t, o) {
    const r = o.mapResult(this.from), s = o.mapResult(this.to);
    return s.deleted ? L.near(t.resolve(r.pos)) : r.deleted ? L.near(t.resolve(s.pos)) : new B(
      t.resolve(r.pos),
      t.resolve(s.pos)
    );
  }
  toJSON() {
    return { type: "multiple-node", anchor: this.anchor, head: this.head };
  }
}
L.jsonID("multiple-node", B);
let S;
function Lt(n, e) {
  let t, o;
  const r = e.resolve(n.from).node().type.spec.group === "blockContent", s = e.resolve(n.to).node().type.spec.group === "blockContent", i = Math.min(n.$anchor.depth, n.$head.depth);
  if (r && s) {
    const a = n.$from.start(i - 1), l = n.$to.end(i - 1);
    t = e.resolve(a - 1).pos, o = e.resolve(l + 1).pos;
  } else
    t = n.from, o = n.to;
  return { from: t, to: o };
}
function te(n, e, t = e) {
  e === t && (t += n.state.doc.resolve(e + 1).node().nodeSize);
  const o = n.domAtPos(e).node.cloneNode(!0), r = n.domAtPos(e).node, s = (u, p) => Array.prototype.indexOf.call(u.children, p), i = s(
    r,
    // Expects from position to be just before the first selected block.
    n.domAtPos(e + 1).node.parentElement
  ), a = s(
    r,
    // Expects to position to be just after the last selected block.
    n.domAtPos(t - 1).node.parentElement
  );
  for (let u = r.childElementCount - 1; u >= 0; u--)
    (u > a || u < i) && o.removeChild(o.children[u]);
  ke(n.root), S = o;
  const l = S.getElementsByTagName("iframe");
  for (let u = 0; u < l.length; u++) {
    const p = l[u], h = p.parentElement;
    h && h.removeChild(p);
  }
  const m = n.dom.className.split(" ").filter(
    (u) => u !== "ProseMirror" && u !== "bn-root" && u !== "bn-editor"
  ).join(" ");
  S.className = S.className + " bn-drag-preview " + m, n.root instanceof ShadowRoot ? n.root.appendChild(S) : n.root.body.appendChild(S);
}
function ke(n) {
  S !== void 0 && (n instanceof ShadowRoot ? n.removeChild(S) : n.body.removeChild(S), S = void 0);
}
function Nt(n, e, t) {
  if (!n.dataTransfer || t.headless)
    return;
  const o = t.prosemirrorView, r = de(e.id, o.state.doc);
  if (!r)
    throw new Error(`Block with ID ${e.id} not found`);
  const s = r.posBeforeNode;
  if (s != null) {
    const i = o.state.selection, a = o.state.doc, { from: l, to: c } = Lt(i, a), m = l <= s && s < c, u = i.$anchor.node() !== i.$head.node() || i instanceof B;
    m && u ? (o.dispatch(
      o.state.tr.setSelection(B.create(a, l, c))
    ), te(o, l, c)) : (o.dispatch(
      o.state.tr.setSelection(se.create(o.state.doc, s))
    ), te(o, s));
    const p = o.state.selection.content(), h = t.pmSchema, f = o.serializeForClipboard(p).dom.innerHTML, d = ye(h, t), g = It(p.content), w = d.exportBlocks(g, {}), y = be(w);
    n.dataTransfer.clearData(), n.dataTransfer.setData("blocknote/html", f), n.dataTransfer.setData("text/html", w), n.dataTransfer.setData("text/plain", y), n.dataTransfer.effectAllowed = "move", n.dataTransfer.setDragImage(S, 0, 0);
  }
}
const oe = 250;
function U(n, e, t = !0) {
  const o = n.root.elementsFromPoint(e.left, e.top);
  for (const r of o)
    if (n.dom.contains(r))
      return t && r.closest("[data-node-type=columnList]") ? U(
        n,
        {
          // TODO can we do better than this?
          left: e.left + 50,
          // bit hacky, but if we're inside a column, offset x position to right to account for the width of sidemenu itself
          top: e.top
        },
        !1
      ) : Ce(r, n);
}
function Rt(n, e) {
  if (!e.dom.firstChild)
    return;
  const t = e.dom.firstChild.getBoundingClientRect(), o = {
    // Clamps the x position to the editor's bounding box.
    left: Math.min(
      Math.max(t.left + 10, n.x),
      t.right - 10
    ),
    top: n.y
  }, r = U(e, o);
  if (!r)
    return;
  const s = r.node.getBoundingClientRect();
  return U(
    e,
    {
      left: s.right - 10,
      top: n.y
    },
    !1
  );
}
class Vt {
  constructor(e, t, o) {
    b(this, "state");
    b(this, "emitUpdate");
    b(this, "mousePos");
    b(this, "hoveredBlock");
    b(this, "menuFrozen", !1);
    b(this, "isDragOrigin", !1);
    b(this, "updateState", (e) => {
      this.state = e, this.emitUpdate(this.state);
    });
    b(this, "updateStateFromMousePos", () => {
      var o, r, s, i, a;
      if (this.menuFrozen || !this.mousePos)
        return;
      const e = this.findClosestEditorElement({
        clientX: this.mousePos.x,
        clientY: this.mousePos.y
      });
      if ((e == null ? void 0 : e.element) !== this.pmView.dom || e.distance > oe) {
        (o = this.state) != null && o.show && (this.state.show = !1, this.updateState(this.state));
        return;
      }
      const t = Rt(this.mousePos, this.pmView);
      if (!t || !this.editor.isEditable) {
        (r = this.state) != null && r.show && (this.state.show = !1, this.updateState(this.state));
        return;
      }
      if (!((s = this.state) != null && s.show && ((i = this.hoveredBlock) != null && i.hasAttribute("data-id")) && ((a = this.hoveredBlock) == null ? void 0 : a.getAttribute("data-id")) === t.id) && (this.hoveredBlock = t.node, this.editor.isEditable)) {
        const l = t.node.getBoundingClientRect(), c = t.node.closest("[data-node-type=column]");
        this.state = {
          show: !0,
          referencePos: new DOMRect(
            c ? (
              // We take the first child as column elements have some default
              // padding. This is a little weird since this child element will
              // be the first block, but since it's always non-nested and we
              // only take the x coordinate, it's ok.
              c.firstElementChild.getBoundingClientRect().x
            ) : this.pmView.dom.firstChild.getBoundingClientRect().x,
            l.y,
            l.width,
            l.height
          ),
          block: this.editor.getBlock(
            this.hoveredBlock.getAttribute("data-id")
          )
        }, this.updateState(this.state);
      }
    });
    /**
     * If a block is being dragged, ProseMirror usually gets the context of what's
     * being dragged from `view.dragging`, which is automatically set when a
     * `dragstart` event fires in the editor. However, if the user tries to drag
     * and drop blocks between multiple editors, only the one in which the drag
     * began has that context, so we need to set it on the others manually. This
     * ensures that PM always drops the blocks in between other blocks, and not
     * inside them.
     *
     * After the `dragstart` event fires on the drag handle, it sets
     * `blocknote/html` data on the clipboard. This handler fires right after,
     * parsing the `blocknote/html` data into nodes and setting them on
     * `view.dragging`.
     *
     * Note: Setting `view.dragging` on `dragover` would be better as the user
     * could then drag between editors in different windows, but you can only
     * access `dataTransfer` contents on `dragstart` and `drop` events.
     */
    b(this, "onDragStart", (e) => {
      var i;
      const t = (i = e.dataTransfer) == null ? void 0 : i.getData("blocknote/html");
      if (!t || this.pmView.dragging)
        return;
      const o = document.createElement("div");
      o.innerHTML = t;
      const s = Ze.fromSchema(this.pmView.state.schema).parse(o, {
        topNode: this.pmView.state.schema.nodes.blockGroup.create()
      });
      this.pmView.dragging = {
        slice: new Qe(s.content, 0, 0),
        move: !0
      };
    });
    /**
     * Finds the closest editor visually to the given coordinates
     */
    b(this, "findClosestEditorElement", (e) => {
      const t = Array.from(this.pmView.root.querySelectorAll(".bn-editor"));
      if (t.length === 0)
        return null;
      let o = t[0], r = Number.MAX_VALUE;
      return t.forEach((s) => {
        const i = s.querySelector(".bn-block-group").getBoundingClientRect(), a = e.clientX < i.left ? i.left - e.clientX : e.clientX > i.right ? e.clientX - i.right : 0, l = e.clientY < i.top ? i.top - e.clientY : e.clientY > i.bottom ? e.clientY - i.bottom : 0, c = Math.sqrt(
          Math.pow(a, 2) + Math.pow(l, 2)
        );
        c < r && (r = c, o = s);
      }), {
        element: o,
        distance: r
      };
    });
    /**
     * This dragover event handler listens at the document level,
     * and is trying to handle dragover events for all editors.
     *
     * It specifically is trying to handle the following cases:
     *  - If the dragover event is within the bounds of any editor, then it does nothing
     *  - If the dragover event is outside the bounds of any editor, but close enough (within DISTANCE_TO_CONSIDER_EDITOR_BOUNDS) to the closest editor,
     *    then it dispatches a synthetic dragover event to the closest editor (which will trigger the drop-cursor to be shown on that editor)
     *  - If the dragover event is outside the bounds of the current editor, then it will dispatch a synthetic dragleave event to the current editor
     *    (which will trigger the drop-cursor to be removed from the current editor)
     *
     * The synthetic event is a necessary evil because we do not control prosemirror-dropcursor to be able to show the drop-cursor within the range we want
     */
    b(this, "onDragOver", (e) => {
      if (e.synthetic)
        return;
      const t = this.getDragEventContext(e);
      if (!t || !t.isDropPoint) {
        this.closeDropCursor();
        return;
      }
      t.isDropPoint && !t.isDropWithinEditorBounds && this.dispatchSyntheticEvent(e);
    });
    /**
     * Closes the drop-cursor for the current editor
     */
    b(this, "closeDropCursor", () => {
      const e = new Event("dragleave", { bubbles: !1 });
      e.synthetic = !0, this.pmView.dom.dispatchEvent(e);
    });
    /**
     * It is surprisingly difficult to determine the information we need to know about a drag event
     *
     * This function is trying to determine the following:
     *  - Whether the current editor instance is the drop point
     *  - Whether the current editor instance is the drag origin
     *  - Whether the drop event is within the bounds of the current editor instance
     */
    b(this, "getDragEventContext", (e) => {
      var l;
      const t = !((l = e.dataTransfer) != null && l.types.includes("blocknote/html")) && !!this.pmView.dragging, o = !!this.isDragOrigin, r = t || o, s = this.findClosestEditorElement(e);
      if (!s || s.distance > oe)
        return;
      const i = s.element === this.pmView.dom, a = i && s.distance === 0;
      if (!(!i && !r))
        return {
          isDropPoint: i,
          isDropWithinEditorBounds: a,
          isDragOrigin: r
        };
    });
    /**
     * The drop event handler listens at the document level,
     * and handles drop events for all editors.
     *
     * It specifically handles the following cases:
     *  - If we are both the drag origin and drop point:
     *    - Let normal drop handling take over
     *  - If we are the drop point but not the drag origin:
     *    - Collapse selection to prevent PM from deleting unrelated content
     *    - If drop event is outside our editor bounds, dispatch synthetic drop event to our editor
     *  - If we are the drag origin but not the drop point:
     *    - Delete the dragged content from our editor after a delay
     */
    b(this, "onDrop", (e) => {
      if (e.synthetic)
        return;
      const t = this.getDragEventContext(e);
      if (!t) {
        this.closeDropCursor();
        return;
      }
      const { isDropPoint: o, isDropWithinEditorBounds: r, isDragOrigin: s } = t;
      if (!r && o && this.dispatchSyntheticEvent(e), o) {
        if (this.pmView.dragging)
          return;
        this.pmView.dispatch(
          this.pmView.state.tr.setSelection(
            Xe.create(
              this.pmView.state.tr.doc,
              this.pmView.state.tr.selection.anchor
            )
          )
        );
        return;
      } else if (s) {
        setTimeout(
          () => this.pmView.dispatch(this.pmView.state.tr.deleteSelection()),
          0
        );
        return;
      }
    });
    b(this, "onDragEnd", (e) => {
      e.synthetic || (this.pmView.dragging = null);
    });
    b(this, "onKeyDown", (e) => {
      var t;
      (t = this.state) != null && t.show && this.editor.isFocused() && (this.state.show = !1, this.emitUpdate(this.state));
    });
    b(this, "onMouseMove", (e) => {
      var s;
      if (this.menuFrozen)
        return;
      this.mousePos = { x: e.clientX, y: e.clientY };
      const t = this.pmView.dom.getBoundingClientRect(), o = this.mousePos.x > t.left && this.mousePos.x < t.right && this.mousePos.y > t.top && this.mousePos.y < t.bottom, r = this.pmView.dom.parentElement;
      if (
        // Cursor is within the editor area
        o && // An element is hovered
        e && e.target && // Element is outside the editor
        !(r === e.target || r.contains(e.target))
      ) {
        (s = this.state) != null && s.show && (this.state.show = !1, this.emitUpdate(this.state));
        return;
      }
      this.updateStateFromMousePos();
    });
    this.editor = e, this.pmView = t, this.emitUpdate = () => {
      if (!this.state)
        throw new Error("Attempting to update uninitialized side menu");
      o(this.state);
    }, this.pmView.root.addEventListener(
      "dragstart",
      this.onDragStart
    ), this.pmView.root.addEventListener(
      "dragover",
      this.onDragOver
    ), this.pmView.root.addEventListener(
      "drop",
      this.onDrop,
      !0
    ), this.pmView.root.addEventListener(
      "dragend",
      this.onDragEnd,
      !0
    ), this.pmView.root.addEventListener(
      "mousemove",
      this.onMouseMove,
      !0
    ), this.pmView.root.addEventListener(
      "keydown",
      this.onKeyDown,
      !0
    );
  }
  dispatchSyntheticEvent(e) {
    const t = new Event(e.type, e), o = this.pmView.dom.firstChild.getBoundingClientRect();
    t.clientX = e.clientX, t.clientY = e.clientY, t.clientX = Math.min(
      Math.max(e.clientX, o.left),
      o.left + o.width
    ), t.clientY = Math.min(
      Math.max(e.clientY, o.top),
      o.top + o.height
    ), t.dataTransfer = e.dataTransfer, t.preventDefault = () => e.preventDefault(), t.synthetic = !0, this.pmView.dom.dispatchEvent(t);
  }
  // Needed in cases where the editor state updates without the mouse cursor
  // moving, as some state updates can require a side menu update. For example,
  // adding a button to the side menu which removes the block can cause the
  // block below to jump up into the place of the removed block when clicked,
  // allowing the user to click the button again without moving the cursor. This
  // would otherwise not update the side menu, and so clicking the button again
  // would attempt to remove the same block again, causing an error.
  update(e, t) {
    var r;
    !t.doc.eq(this.pmView.state.doc) && ((r = this.state) != null && r.show) && this.updateStateFromMousePos();
  }
  destroy() {
    var e;
    (e = this.state) != null && e.show && (this.state.show = !1, this.emitUpdate(this.state)), this.pmView.root.removeEventListener(
      "mousemove",
      this.onMouseMove,
      !0
    ), this.pmView.root.removeEventListener(
      "dragstart",
      this.onDragStart
    ), this.pmView.root.removeEventListener(
      "dragover",
      this.onDragOver
    ), this.pmView.root.removeEventListener(
      "drop",
      this.onDrop,
      !0
    ), this.pmView.root.removeEventListener(
      "dragend",
      this.onDragEnd,
      !0
    ), this.pmView.root.removeEventListener(
      "keydown",
      this.onKeyDown,
      !0
    );
  }
}
const Ft = new ue("SideMenuPlugin"), Io = v(({ editor: n }) => {
  let e;
  const t = F(
    void 0
  );
  return {
    key: "sideMenu",
    store: t,
    prosemirrorPlugins: [
      new he({
        key: Ft,
        view: (o) => (e = new Vt(n, o, (r) => {
          t.setState({ ...r });
        }), e)
      })
    ],
    /**
     * Handles drag & drop events for blocks.
     */
    blockDragStart(o, r) {
      e && (e.isDragOrigin = !0), Nt(o, r, n);
    },
    /**
     * Handles drag & drop events for blocks.
     */
    blockDragEnd() {
      ke(n.prosemirrorView.root), e && (e.isDragOrigin = !1), n.blur();
    },
    /**
     * Freezes the side menu. When frozen, the side menu will stay
     * attached to the same block regardless of which block is hovered by the
     * mouse cursor.
     */
    freezeMenu() {
      e.menuFrozen = !0, e.state.show = !0, e.emitUpdate(e.state);
    },
    /**
     * Unfreezes the side menu. When frozen, the side menu will stay
     * attached to the same block regardless of which block is hovered by the
     * mouse cursor.
     */
    unfreezeMenu() {
      e.menuFrozen = !1, e.state.show = !1, e.emitUpdate(e.state);
    }
  };
});
let C;
function ne(n) {
  C || (C = document.createElement("div"), C.innerHTML = "_", C.style.opacity = "0", C.style.height = "1px", C.style.width = "1px", n instanceof Document ? n.body.appendChild(C) : n.appendChild(C));
}
function Ht(n) {
  C && (n instanceof Document ? n.body.removeChild(C) : n.removeChild(C), C = void 0);
}
function M(n) {
  return Array.prototype.indexOf.call(n.parentElement.childNodes, n);
}
function $t(n) {
  let e = n;
  for (; e && e.nodeName !== "TD" && e.nodeName !== "TH" && !e.classList.contains("tableWrapper"); ) {
    if (e.classList.contains("ProseMirror"))
      return;
    const t = e.parentNode;
    if (!t || !(t instanceof Element))
      return;
    e = t;
  }
  return e.nodeName === "TD" || e.nodeName === "TH" ? {
    type: "cell",
    domNode: e,
    tbodyNode: e.closest("tbody")
  } : {
    type: "wrapper",
    domNode: e,
    tbodyNode: e.querySelector("tbody")
  };
}
function Ut(n, e) {
  const t = e.querySelectorAll(n);
  for (let o = 0; o < t.length; o++)
    t[o].style.visibility = "hidden";
}
class _t {
  constructor(e, t, o) {
    b(this, "state");
    b(this, "emitUpdate");
    b(this, "tableId");
    b(this, "tablePos");
    b(this, "tableElement");
    b(this, "menuFrozen", !1);
    b(this, "mouseState", "up");
    b(this, "prevWasEditable", null);
    b(this, "viewMousedownHandler", () => {
      this.mouseState = "down";
    });
    b(this, "mouseUpHandler", (e) => {
      this.mouseState = "up", this.mouseMoveHandler(e);
    });
    b(this, "mouseMoveHandler", (e) => {
      var c, m, u, p, h, f, d;
      if (this.menuFrozen || this.mouseState === "selecting" || !(e.target instanceof Element) || !this.pmView.dom.contains(e.target))
        return;
      const t = $t(e.target);
      if ((t == null ? void 0 : t.type) === "cell" && this.mouseState === "down" && !((c = this.state) != null && c.draggingState)) {
        this.mouseState = "selecting", (m = this.state) != null && m.show && (this.state.show = !1, this.state.showAddOrRemoveRowsButton = !1, this.state.showAddOrRemoveColumnsButton = !1, this.emitUpdate());
        return;
      }
      if (!t || !this.editor.isEditable) {
        (u = this.state) != null && u.show && (this.state.show = !1, this.state.showAddOrRemoveRowsButton = !1, this.state.showAddOrRemoveColumnsButton = !1, this.emitUpdate());
        return;
      }
      if (!t.tbodyNode)
        return;
      const o = t.tbodyNode.getBoundingClientRect(), r = Ce(t.domNode, this.pmView);
      if (!r)
        return;
      this.tableElement = r.node;
      let s;
      const i = this.editor.transact(
        (g) => de(r.id, g.doc)
      );
      if (!i)
        throw new Error(`Block with ID ${r.id} not found`);
      const a = R(
        i.node,
        this.editor.pmSchema,
        this.editor.schema.blockSchema,
        this.editor.schema.inlineContentSchema,
        this.editor.schema.styleSchema
      );
      if (a.type === "table" && (this.tablePos = i.posBeforeNode + 1, s = a), !s)
        return;
      this.tableId = r.id;
      const l = (p = t.domNode.closest(".tableWrapper")) == null ? void 0 : p.querySelector(".table-widgets-container");
      if ((t == null ? void 0 : t.type) === "wrapper") {
        const g = e.clientY >= o.bottom - 1 && // -1 to account for fractions of pixels in "bottom"
        e.clientY < o.bottom + 20, w = e.clientX >= o.right - 1 && e.clientX < o.right + 20, y = e.clientX > o.right || e.clientY > o.bottom;
        this.state = {
          ...this.state,
          show: !0,
          showAddOrRemoveRowsButton: g,
          showAddOrRemoveColumnsButton: w,
          referencePosTable: o,
          block: s,
          widgetContainer: l,
          colIndex: y || (h = this.state) == null ? void 0 : h.colIndex,
          rowIndex: y || (f = this.state) == null ? void 0 : f.rowIndex,
          referencePosCell: y || (d = this.state) == null ? void 0 : d.referencePosCell
        };
      } else {
        const g = M(t.domNode), w = M(t.domNode.parentElement), y = t.domNode.getBoundingClientRect();
        if (this.state !== void 0 && this.state.show && this.tableId === r.id && this.state.rowIndex === w && this.state.colIndex === g)
          return;
        this.state = {
          show: !0,
          showAddOrRemoveColumnsButton: g === s.content.rows[0].cells.length - 1,
          showAddOrRemoveRowsButton: w === s.content.rows.length - 1,
          referencePosTable: o,
          block: s,
          draggingState: void 0,
          referencePosCell: y,
          colIndex: g,
          rowIndex: w,
          widgetContainer: l
        };
      }
      return this.emitUpdate(), !1;
    });
    b(this, "dragOverHandler", (e) => {
      var p;
      if (((p = this.state) == null ? void 0 : p.draggingState) === void 0)
        return;
      e.preventDefault(), e.dataTransfer.dropEffect = "move", Ut(
        ".prosemirror-dropcursor-block, .prosemirror-dropcursor-inline",
        this.pmView.root
      );
      const t = {
        left: Math.min(
          Math.max(e.clientX, this.state.referencePosTable.left + 1),
          this.state.referencePosTable.right - 1
        ),
        top: Math.min(
          Math.max(e.clientY, this.state.referencePosTable.top + 1),
          this.state.referencePosTable.bottom - 1
        )
      }, o = this.pmView.root.elementsFromPoint(t.left, t.top).filter(
        (h) => h.tagName === "TD" || h.tagName === "TH"
      );
      if (o.length === 0)
        return;
      const r = o[0];
      let s = !1;
      const i = M(r.parentElement), a = M(r), l = this.state.draggingState.draggedCellOrientation === "row" ? this.state.rowIndex : this.state.colIndex, m = (this.state.draggingState.draggedCellOrientation === "row" ? i : a) !== l;
      (this.state.rowIndex !== i || this.state.colIndex !== a) && (this.state.rowIndex = i, this.state.colIndex = a, this.state.referencePosCell = r.getBoundingClientRect(), s = !0);
      const u = this.state.draggingState.draggedCellOrientation === "row" ? t.top : t.left;
      this.state.draggingState.mousePos !== u && (this.state.draggingState.mousePos = u, s = !0), s && this.emitUpdate(), m && this.editor.transact((h) => h.setMeta(D, !0));
    });
    b(this, "dropHandler", (e) => {
      if (this.mouseState = "up", this.state === void 0 || this.state.draggingState === void 0)
        return !1;
      if (this.state.rowIndex === void 0 || this.state.colIndex === void 0)
        throw new Error(
          "Attempted to drop table row or column, but no table block was hovered prior."
        );
      e.preventDefault();
      const { draggingState: t, colIndex: o, rowIndex: r } = this.state, s = this.state.block.content.columnWidths;
      if (t.draggedCellOrientation === "row") {
        if (!ae(
          this.state.block,
          t.originalIndex,
          r
        ))
          return !1;
        const i = Me(
          this.state.block,
          t.originalIndex,
          r
        );
        this.editor.updateBlock(this.state.block, {
          type: "table",
          content: {
            ...this.state.block.content,
            rows: i
          }
        });
      } else {
        if (!le(
          this.state.block,
          t.originalIndex,
          o
        ))
          return !1;
        const i = Le(
          this.state.block,
          t.originalIndex,
          o
        ), [a] = s.splice(t.originalIndex, 1);
        s.splice(o, 0, a), this.editor.updateBlock(this.state.block, {
          type: "table",
          content: {
            ...this.state.block.content,
            columnWidths: s,
            rows: i
          }
        });
      }
      return this.editor.setTextCursorPosition(this.state.block.id), !0;
    });
    this.editor = e, this.pmView = t, this.emitUpdate = () => {
      if (!this.state)
        throw new Error("Attempting to update uninitialized image toolbar");
      o(this.state);
    }, t.dom.addEventListener("mousemove", this.mouseMoveHandler), t.dom.addEventListener("mousedown", this.viewMousedownHandler), window.addEventListener("mouseup", this.mouseUpHandler), t.root.addEventListener(
      "dragover",
      this.dragOverHandler
    ), t.root.addEventListener(
      "drop",
      this.dropHandler
    );
  }
  // Updates drag handles when the table is modified or removed.
  update() {
    var s;
    if (!this.state || !this.state.show)
      return;
    const e = this.editor.getBlock(this.state.block.id);
    if (!e || e.type !== "table" || // when collaborating, the table element might be replaced and out of date
    // because yjs replaces the element when for example you change the color via the side menu
    !((s = this.tableElement) != null && s.isConnected)) {
      this.state.show = !1, this.state.showAddOrRemoveRowsButton = !1, this.state.showAddOrRemoveColumnsButton = !1, this.emitUpdate();
      return;
    }
    this.state.block = e;
    const { height: t, width: o } = Ne(
      this.state.block
    );
    this.state.rowIndex !== void 0 && this.state.colIndex !== void 0 && (this.state.rowIndex >= t && (this.state.rowIndex = t - 1), this.state.colIndex >= o && (this.state.colIndex = o - 1));
    const r = this.tableElement.querySelector("tbody");
    if (!r)
      throw new Error(
        "Table block does not contain a 'tbody' HTML element. This should never happen."
      );
    if (this.state.rowIndex !== void 0 && this.state.colIndex !== void 0) {
      const a = r.children[this.state.rowIndex].children[this.state.colIndex];
      a ? this.state.referencePosCell = a.getBoundingClientRect() : (this.state.rowIndex = void 0, this.state.colIndex = void 0);
    }
    this.state.referencePosTable = r.getBoundingClientRect(), this.emitUpdate();
  }
  destroy() {
    this.pmView.dom.removeEventListener("mousemove", this.mouseMoveHandler), window.removeEventListener("mouseup", this.mouseUpHandler), this.pmView.dom.removeEventListener("mousedown", this.viewMousedownHandler), this.pmView.root.removeEventListener(
      "dragover",
      this.dragOverHandler
    ), this.pmView.root.removeEventListener(
      "drop",
      this.dropHandler
    );
  }
}
const D = new T("TableHandlesPlugin"), Bo = v(({ editor: n }) => {
  let e;
  const t = F(void 0);
  return {
    key: "tableHandles",
    store: t,
    prosemirrorPlugins: [
      new P({
        key: D,
        view: (o) => (e = new _t(n, o, (r) => {
          t.setState({
            ...r,
            draggingState: r.draggingState ? { ...r.draggingState } : void 0
          });
        }), e),
        // We use decorations to render the drop cursor when dragging a table row
        // or column. The decorations are updated in the `dragOverHandler` method.
        props: {
          decorations: (o) => {
            if (e === void 0 || e.state === void 0 || e.state.draggingState === void 0 || e.tablePos === void 0)
              return;
            const r = e.state.draggingState.draggedCellOrientation === "row" ? e.state.rowIndex : e.state.colIndex;
            if (r === void 0)
              return;
            const s = [], { block: i, draggingState: a } = e.state, { originalIndex: l, draggedCellOrientation: c } = a;
            if (r === l || !i || c === "row" && !ae(i, l, r) || c === "col" && !le(i, l, r))
              return V.create(o.doc, s);
            const m = o.doc.resolve(e.tablePos + 1);
            return e.state.draggingState.draggedCellOrientation === "row" ? j(
              e.state.block,
              r
            ).forEach(({ row: p, col: h }) => {
              const f = o.doc.resolve(
                m.posAtIndex(p) + 1
              ), d = o.doc.resolve(
                f.posAtIndex(h) + 1
              ), g = d.node(), w = d.pos + (r > l ? g.nodeSize - 2 : 0);
              s.push(
                // The widget is a small bar which spans the width of the cell.
                A.widget(w, () => {
                  const y = document.createElement("div");
                  return y.className = "bn-table-drop-cursor", y.style.left = "0", y.style.right = "0", r > l ? y.style.bottom = "-2px" : y.style.top = "-3px", y.style.height = "4px", y;
                })
              );
            }) : q(
              e.state.block,
              r
            ).forEach(({ row: p, col: h }) => {
              const f = o.doc.resolve(
                m.posAtIndex(p) + 1
              ), d = o.doc.resolve(
                f.posAtIndex(h) + 1
              ), g = d.node(), w = d.pos + (r > l ? g.nodeSize - 2 : 0);
              s.push(
                // The widget is a small bar which spans the height of the cell.
                A.widget(w, () => {
                  const y = document.createElement("div");
                  return y.className = "bn-table-drop-cursor", y.style.top = "0", y.style.bottom = "0", r > l ? y.style.right = "-2px" : y.style.left = "-3px", y.style.width = "4px", y;
                })
              );
            }), V.create(o.doc, s);
          }
        }
      })
    ],
    /**
     * Callback that should be set on the `dragStart` event for whichever element
     * is used as the column drag handle.
     */
    colDragStart(o) {
      if (e === void 0 || e.state === void 0 || e.state.colIndex === void 0)
        throw new Error(
          "Attempted to drag table column, but no table block was hovered prior."
        );
      e.state.draggingState = {
        draggedCellOrientation: "col",
        originalIndex: e.state.colIndex,
        mousePos: o.clientX
      }, e.emitUpdate(), n.transact(
        (r) => r.setMeta(D, {
          draggedCellOrientation: e.state.draggingState.draggedCellOrientation,
          originalIndex: e.state.colIndex,
          newIndex: e.state.colIndex,
          tablePos: e.tablePos
        })
      ), !n.headless && (ne(n.prosemirrorView.root), o.dataTransfer.setDragImage(C, 0, 0), o.dataTransfer.effectAllowed = "move");
    },
    /**
     * Callback that should be set on the `dragStart` event for whichever element
     * is used as the row drag handle.
     */
    rowDragStart(o) {
      if (e.state === void 0 || e.state.rowIndex === void 0)
        throw new Error(
          "Attempted to drag table row, but no table block was hovered prior."
        );
      e.state.draggingState = {
        draggedCellOrientation: "row",
        originalIndex: e.state.rowIndex,
        mousePos: o.clientY
      }, e.emitUpdate(), n.transact(
        (r) => r.setMeta(D, {
          draggedCellOrientation: e.state.draggingState.draggedCellOrientation,
          originalIndex: e.state.rowIndex,
          newIndex: e.state.rowIndex,
          tablePos: e.tablePos
        })
      ), !n.headless && (ne(n.prosemirrorView.root), o.dataTransfer.setDragImage(C, 0, 0), o.dataTransfer.effectAllowed = "copyMove");
    },
    /**
     * Callback that should be set on the `dragEnd` event for both the element
     * used as the row drag handle, and the one used as the column drag handle.
     */
    dragEnd() {
      if (e.state === void 0)
        throw new Error(
          "Attempted to drag table row, but no table block was hovered prior."
        );
      e.state.draggingState = void 0, e.emitUpdate(), n.transact((o) => o.setMeta(D, null)), !n.headless && Ht(n.prosemirrorView.root);
    },
    /**
     * Freezes the drag handles. When frozen, they will stay attached to the same
     * cell regardless of which cell is hovered by the mouse cursor.
     */
    freezeHandles() {
      e.menuFrozen = !0;
    },
    /**
     * Unfreezes the drag handles. When frozen, they will stay attached to the
     * same cell regardless of which cell is hovered by the mouse cursor.
     */
    unfreezeHandles() {
      e.menuFrozen = !1;
    },
    getCellsAtRowHandle(o, r) {
      return j(o, r);
    },
    /**
     * Get all the cells in a column of the table block.
     */
    getCellsAtColumnHandle(o, r) {
      return q(o, r);
    },
    /**
     * Sets the selection to the given cell or a range of cells.
     * @returns The new state after the selection has been set.
     */
    setCellSelection(o, r, s = r) {
      if (!e)
        throw new Error("Table handles view not initialized");
      const i = o.doc.resolve(e.tablePos + 1), a = o.doc.resolve(
        i.posAtIndex(r.row) + 1
      ), l = o.doc.resolve(
        // No need for +1, since CellSelection expects the position before the cell
        a.posAtIndex(r.col)
      ), c = o.doc.resolve(
        i.posAtIndex(s.row) + 1
      ), m = o.doc.resolve(
        // No need for +1, since CellSelection expects the position before the cell
        c.posAtIndex(s.col)
      ), u = o.tr;
      return u.setSelection(
        new gt(l, m)
      ), o.apply(u);
    },
    /**
     * Adds a row or column to the table using prosemirror-table commands
     */
    addRowOrColumn(o, r) {
      n.exec((s, i) => {
        const a = this.setCellSelection(
          s,
          r.orientation === "row" ? { row: o, col: 0 } : { row: 0, col: o }
        );
        return r.orientation === "row" ? r.side === "above" ? ht(a, i) : mt(a, i) : r.side === "left" ? pt(a, i) : ft(a, i);
      });
    },
    /**
     * Removes a row or column from the table using prosemirror-table commands
     */
    removeRowOrColumn(o, r) {
      return r === "row" ? n.exec((s, i) => {
        const a = this.setCellSelection(s, {
          row: o,
          col: 0
        });
        return dt(a, i);
      }) : n.exec((s, i) => {
        const a = this.setCellSelection(s, {
          row: 0,
          col: o
        });
        return ut(a, i);
      });
    },
    /**
     * Merges the cells in the table block.
     */
    mergeCells(o) {
      return n.exec((r, s) => {
        const i = o ? this.setCellSelection(
          r,
          o.relativeStartCell,
          o.relativeEndCell
        ) : r;
        return ct(i, s);
      });
    },
    /**
     * Splits the cell in the table block.
     * If no cell is provided, the current cell selected will be split.
     */
    splitCell(o) {
      return n.exec((r, s) => {
        const i = o ? this.setCellSelection(r, o) : r;
        return lt(i, s);
      });
    },
    /**
     * Gets the start and end cells of the current cell selection.
     * @returns The start and end cells of the current cell selection.
     */
    getCellSelection() {
      return n.transact((o) => {
        const r = o.selection;
        let s = r.$from, i = r.$to;
        if (W(r)) {
          const { ranges: d } = r;
          d.forEach((g) => {
            s = g.$from.min(s ?? g.$from), i = g.$to.max(i ?? g.$to);
          });
        } else if (s = o.doc.resolve(
          r.$from.pos - r.$from.parentOffset - 1
        ), i = o.doc.resolve(
          r.$to.pos - r.$to.parentOffset - 1
        ), s.pos === 0 || i.pos === 0)
          return;
        const a = o.doc.resolve(
          s.pos - s.parentOffset - 1
        ), l = o.doc.resolve(i.pos - i.parentOffset - 1), c = o.doc.resolve(a.pos - a.parentOffset - 1), m = s.index(a.depth), u = a.index(c.depth), p = i.index(l.depth), h = l.index(c.depth), f = [];
        for (let d = u; d <= h; d++)
          for (let g = m; g <= p; g++)
            f.push({ row: d, col: g });
        return {
          from: {
            row: u,
            col: m
          },
          to: {
            row: h,
            col: p
          },
          cells: f
        };
      });
    },
    /**
     * Gets the direction of the merge based on the current cell selection.
     *
     * Returns undefined when there is no cell selection, or the selection is not within a table.
     */
    getMergeDirection(o) {
      return n.transact((r) => {
        const s = W(r.selection) ? r.selection : void 0;
        if (!s || !o || // Only offer the merge button if there is more than one cell selected.
        s.ranges.length <= 1)
          return;
        const i = this.getCellSelection();
        if (i)
          return Fe(i.from, i.to, o) ? "vertical" : "horizontal";
      });
    },
    cropEmptyRowsOrColumns(o, r) {
      return Ve(o, r);
    },
    addRowsOrColumns(o, r, s) {
      return Re(o, r, s);
    }
  };
}), re = new T("trailingNode"), Po = v(() => ({
  key: "trailingNode",
  prosemirrorPlugins: [
    new P({
      key: re,
      appendTransaction: (n, e, t) => {
        const { doc: o, tr: r, schema: s } = t, i = re.getState(t), a = o.content.size - 2, l = s.nodes.blockContainer, c = s.nodes.paragraph;
        if (i)
          return r.insert(
            a,
            l.create(void 0, c.create())
          );
      },
      state: {
        init: (n, e) => {
        },
        apply: (n, e) => {
          if (!n.docChanged)
            return e;
          let t = n.doc.lastChild;
          if (!t || t.type.name !== "blockGroup")
            throw new Error("Expected blockGroup");
          if (t = t.lastChild, !t || t.type.name !== "blockContainer")
            return !0;
          const o = t.firstChild;
          if (!o)
            throw new Error("Expected blockContent");
          return t.nodeSize > 4 || o.type.spec.content !== "inline*";
        }
      }
    })
  ]
}));
export {
  fo as B,
  yo as D,
  go as F,
  bo as H,
  vo as L,
  So as N,
  xo as P,
  wo as S,
  _t as T,
  Co as V,
  Q as Y,
  H as a,
  $ as b,
  mo as c,
  ko as d,
  Eo as e,
  Vt as f,
  Io as g,
  Bo as h,
  Po as i,
  kt as j,
  ye as k,
  po as l,
  be as m,
  It as n,
  Ft as s,
  D as t
};
//# sourceMappingURL=TrailingNode-unN5_Fik.js.map
